// Generated from SVG to Code Figma Plugin

export const BaseLineSearch = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58174 15.4183 3 11 3C6.58174 3 3 6.58174 3 11C3 15.4183 6.58174 19 11 19Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M17 17L20 20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);
